import { NotificationNavigationTarget } from '@/lib/notification-navigation'

type OpenChatFn = (
  targetUserId?: number,
  targetUserName?: string,
  conversationId?: number,
  jobName?: string,
  targetUserAvatar?: string
) => void

export function applyNotificationNavigation(
  target: NotificationNavigationTarget,
  options: {
    push: (href: string) => void | Promise<boolean>
    openChat: OpenChatFn
  }
): void {
  switch (target.kind) {
    case 'detail':
    case 'topic':
      void options.push(target.href)
      break
    case 'chat':
      options.openChat(undefined, undefined, target.conversationId)
      break
    case 'href':
      if (target.href.startsWith('http')) {
        window.location.href = target.href
      } else {
        void options.push(target.href)
      }
      break
    default:
      break
  }
}
